module.exports = __webpack_public_path__ + "img/top_photo.8c751715.svg";